import React from 'react'
import { useSelector } from 'react-redux';
import cx from 'classnames'
import s from './Landscape.module.scss'

import RotatePhone from 'assets/images/phone-rotate.png'
import Background from 'assets/images/blue-bg.png'

Landscape.defaultProps = {
  
};

export default function Landscape(props) {
	const { isLandscape } = useSelector(state => state.ui)

  return (
		<div className={cx(s.Landscape, {[s.active]: isLandscape})}>
			<div className={s.background}>
        <img className={s.bg} src={Background} alt="" />
      </div>
			<div className={s.content}>
				<p className={s.usage}>Dashing to the Store<br/>uses portrait controls.</p>
				<img className={s.rotateImg} src={RotatePhone} alt="" />
				<p className={s.instructions}>Please rotate your<br/>phone to begin.</p>
			</div>
		</div>
  )
}
